require('./csvTable.scss')

module.exports = {
  template: require('./csvTable.pug')()
  controller: require('./csvTable.ctrl')
  bindings:
    csv: '<'
}
